import { Controller } from 'stimulus';

class OutdatedBrowserController extends Controller {
  connect() {
    this.checkForOutdatedBrowser();
  }

  checkForOutdatedBrowser() {
    if (this._uaContains('MSIE ') || this._uaContains('Trident/')) {
      this._createBanner();
    } else {
      this.element.remove();
    }
  }

  _uaContains(string) {
    return window.navigator.userAgent.indexOf(string) >= 0;
  }

  _createBanner() {
    const bannerHTML = `
      <p
        class="pro-Alert pro-Alert-persist pro-Alert--warning"
        role="alert"
        data-controller="alert"
        data-alert-persist
      >
        <span class="pro-Alert-text">
          It looks like your browser is a little outdated, you can
          <a
            class="rds-Link rds-Link--large"
            href="https://www.ramseysolutions.com/error-pages/browser-upgrade"
            target="_blank"
          >
            view a list of supported browsers.
          </a>
        </span>
        <span class="pro-Icon">
          <button
            type="button"
            class="rds-Button rds-Button--subtle"
            id="alert-close-button"
            data-action="alert#remove"
            data-testid="alert_close_button"
          >
            &#10005;
          </button>
        </span>
      </p>
    `;

    const browserBanner = document.querySelector('#pro-browser-banner');
    browserBanner.insertAdjacentHTML('afterend', bannerHTML);
  }
}

export default OutdatedBrowserController;
